<div class="compound-field">
    <div class="field">
        <label soho-label [for]="dimensionId">
            {{ 'Dimension' | translate }}
        </label>
        <select
                [id]="dimensionId"
                [name]="dimensionId"
                soho-dropdown noSearch
                [(ngModel)]="selectedDimension"
                (change)="dimensionChanged = true"
        >
            <option *ngFor="let item of dimensions; trackBy: trackByValueDimension" [ngValue]="item.value">{{item.label}}</option>
         </select>
    </div>

    <div class="field">
        <label soho-label [for]="totalId">
            {{ 'Total' | translate }}
        </label>
        <select
                [id]="totalId"
                [name]="totalId"
                soho-dropdown noSearch
                [(ngModel)]="selectedTotal"
                (change)="totalChanged = true"
        >
            <option *ngFor="let item of totals; trackBy: trackByValueTotal" [ngValue]="item.value">{{item.label}}</option>
        </select>
    </div>

    <div class="field">
        <label soho-label [for]="orderById">
            {{ 'OrderBy' | translate }}
        </label>
        <select
                [id]="orderById"
                [name]="orderById"
                soho-dropdown noSearch
                [(ngModel)]="selectedOrderBy"
                (change)="orderByChanged = true"
        >
            <option *ngFor="let item of orderBy; trackBy: trackByValueOrderBy" [ngValue]="item.value">{{item.label}}</option>
        </select>
    </div>

    <div class="field">
        <input
                [id]="isAscendingId"
                type="checkbox"
                soho-checkbox
                [(ngModel)]="isAscending"
                (change)="isAscendingChanged = true"
        >
        <label soho-label [for]="isAscendingId" [forCheckBox]="true">
            {{ 'Ascending' | translate }}
        </label>
    </div>
</div>